export interface Task {
  readonly id: TaskId;
}

export interface TodoTask extends Task {
  readonly duration?: TodoDuration;
  readonly externalLink?: string;
  readonly status: TaskStatus;
  readonly date?: string;
}

export interface TodoDuration {
  readonly amount: number;
  readonly measure: TaskDurationMeasure;
  readonly progress?: number;
}

export enum TaskDurationMeasure {
  Minutes = 'Minutes',
  Documents = 'Documents',
  TimeBetween = 'TimeBetween'
}
export enum TaskStatus {
  Default = 'Default',
  Problem = 'Problem',
  Disabled = 'Disabled'
}

export type FutureTask = Task;

export interface DoneTask extends Task {
  readonly dateFinished?: string;
  readonly externalLink?: string;
  readonly isSuccessful: boolean;
  readonly showButton: boolean;
}

export type FailedTask = Task;

export enum TaskId {
  chooseAdviceOrExecutionOnly = 'choose_advice_or_execution_only',
  makeCalculationGeneric = 'make_a_calculation_generic',
  makeCalculationVerhogen = 'make_a_calculation_verhogen',
  submitDocuments = 'submit_documents',
  knowledgeTest = 'do_the_ket',
  makeAppointment = 'make_appointment',
  yourAppointment = 'your_appointment',
  yourAppointmentWithAdvice = 'your_appointment_with_advice',
  yourAppointmentRevision = 'your_appointment_revision',
  yourAppointmentExecutionOnly = 'your_appointment_execution_only',
  yourOrientationAppointment = 'your_orientation_appointment',
  signOffer = 'sign_offer',
  housingConsultationSummary = 'housing_consultation_summary',
  mortgagePayment = 'mortgage_payment',
  visitNotary = 'visit_notary',
  processFinished = 'process_finished'
}
